









































import { APInotLoggedIn } from '@/plugins/axios';
import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({})
export default class LoginForm extends Vue {
  @Ref('loginForm') loginForm!: Vue;

  validLoginForm = true;
  formSent = false;
  error = false;

  registerData = {
    email: '',
  };

  registerDataValidations = {
    email: [(v: string) => !!v || 'E-mail is required', (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
  };

  async submitRegister() {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.loginForm as any).validate()) {
      // TODO: Move to action, set axios
      try {
        const { status } = await APInotLoggedIn.post(`/api/misc/resetpwdreq/`, {
          email: this.registerData.email,
        });
        if (status === 200) {
          this.formSent = true;
        } else {
          this.error = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }
    /* eslint-enable @typescript-eslint/camelcase */
  }
}
